export const updateModellStahltreppe = ev => {
    return {
        type: 'UPDATEMODELLSTAHLTREPPE',
        ev: ev
    }
}

export const updateMusteStahltreppe = ev => {
    return {
        type: 'UPDATEMUSTERSTAHLTREPPE',
        ev: ev
    }
}

export const updateProductIndexStahltreppe = ev => {
    return {
        type: 'UPDATEPRODUCTINDEXSTAHLTREPPE',
        ev: ev
    }
}

export const updateTitelModellStahltreppen = ev => {
    return {
        type: 'UPDATETITELMODELLSTAHLTREPPEN',
        ev: ev
    }
}

export const updateStepsStahltreppe = ev => {
    return {
        type: 'UPDATESTEPSSTAHLTREPPE',
        ev: ev
    }
}

export const updateAllVisitedStepsStahltreppe = () => {
    return {
        type: 'UPDATEALLVISITEDSTEPSSTAHLTREPPE'
    }
}

export const updateHandlaufFormStahltreppen = ev => {
    return {
        type: 'UPDATEHANDLAUFFORMSTAHLTREPPEN',
        ev: ev
    }
}

export const updateHandlaufEndkappeStahltreppen = ev => {
    return {
        type: 'UPDATEHANDLAUFENDKAPPESTAHLTREPPEN',
        ev: ev
    }
}

export const updateGelaenderTypeStahlgelaender = ev => {
     return {
         type: 'UPDATEGELAENDERTYPESTAHLGELAENDER',
         ev: ev
     }
}

export const selectStahltreppenHeight = ev => {
    return {
        type: 'SELECTSTAHLTREPPENHEIGHT',
        ev: ev
    }
}

export const selectStufenBreite = ev => {
    return {
        type: 'SELECTSTUFENBREITE',
        ev: ev
    }
}

export const updatePodest = ev => {
    return {
        type: 'UPDATEPODEST',
        ev: ev
    }
}

export const updatePodestWidth = ev => {
    return {
        type: 'UPDATEPODESTWIDTH',
        ev: ev
    }
}

export const selectKindOfColorStahltreppen = ev => {
    return {
        type: 'SELECTKINDOFCOLORSTAHLTREPPEN',
        ev: ev
    }
}

export const selectColorStahltreppen = ev => {
    return {
        type: 'SELECTCOLORSTAHLTREPPEN',
        ev: ev
    }
}

export const selectWishColorStahltreppen = ev => {
    return {
        type: 'SELECTWISHCOLORSTAHLTREPPEN',
        ev: ev
    }
}

export const selectUploadDataStahltreppen = ev => {
    return {
        type: 'SELECTUPLOADDATASTAHLTREPPEN',
        ev: ev
    }
}

export const updateDescriptionStahltreppen = ev => {
    return {
        type: 'UPDATEDESCRIPTIONSTAHLTREPPEN',
        ev: ev
    }
}

export const updateProductToMerklisteStahltreppe = () => {
    return {
        type: 'UPDATEPRODUCTTOPMERKLISTESTAHLTREPPE'
    }
}

export const updateEditStahltreppe = () => {
    return {
        type: 'UPDATEEDITSTAHLTREPPE'
    }
}
